import { BaseCard } from '@bnnvara/cards';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';
import Link from '../../Link';

export const FullWidthCard = ({ title, slug, tags, image }) => (
  <GridItem
    fullWidth
    columnEndSm="span 12"
    columnEndMd="span 12"
    columnEndLg="span 12"
    columnEndXl="span 12"
    key={slug}
  >
    <Link href={slug}>
      <BaseCard
        title={title}
        tag={tags.length > 0 ? tags[0].name : null}
        backgroundImage={resizeImageSource(image.url, 450)}
        wide
        titleSizeSm="22px"
        titleSizeMd="30px"
        titleSizeLg="34px"
        minHeightLg="500px"
      />
    </Link>
  </GridItem>
);

FullWidthCard.defaultProps = {
  image: null,
  tags: [],
};

FullWidthCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
};

export default FullWidthCard;
